<template>
	<div class="h-120 flex items-center justify-between bg-#0F0F17">
		<div @click="reToPage(item.key)" v-for="(item, index) in menuList" class="flex-1 flex flex-col items-center justify-center">
			<img v-if="activeMenu === item.key" class="w-46 h-46" :src="item.activeIcon" alt="">
			<img v-else class="w-46 h-46" :src="item.icon" alt="">
			<span class="mt-4 text-20" :class="[activeMenu === item.key ? 'text-white' : 'text-#999']">{{
				$t(item.nameKey) }}</span>
		</div>
	</div>
</template>

<script>
import utils from "@/utils/utils.js";
export default {
	components: {
	},
	props: {
		activeMenu: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			menuList: [
				{
					id: 1,
					nameKey: 'NUT.菜单.首页',
					key: 'nut-home',
					// 使用require导入图片
					icon: require('@/assets/images/common/nut-menu/home.png'),
					activeIcon: require('@/assets/images/common/nut-menu/home_active.png'),
					path: "/nut-home"
				},
				{
					id: 2,
					nameKey: 'NUT.菜单.奖励',
					key: 'nut-reward',
					icon: require('@/assets/images/common/nut-menu/reward.png'),
					activeIcon: require('@/assets/images/common/nut-menu/reward_active.png'),
					path: "/nut-reward"
				},
				{
					id: 3,
					nameKey: 'NUT.菜单.介绍',
					key: 'nut-introduction',
					icon: require('@/assets/images/common/nut-menu/introduction.png'),
					activeIcon: require('@/assets/images/common/nut-menu/introduction_active.png'),
					path: "/nut-introduction"
				},
				{
					id: 4,
					nameKey: 'NUT.菜单.奖励池',
					key: 'nut-reward-pool',
					icon: require('@/assets/images/common/nut-menu/reward_pool.png'),
					activeIcon: require('@/assets/images/common/nut-menu/reward_pool_active.png'),
					path: "/nut-reward-pool"
				},
			]
		};
	},
	computed: {},
	created() { },
	methods: {
		reToPage(path) {
			console.log(path);
			utils.reToPage(path);
		},
	},
}
</script>

<style></style>
